<script lang="ts" setup>
interface propType {
  data: {
    id: number
    translations: DirectusTranslation<{
      items: {
        title: string
        description: string
      }[]
    }>
  }
}

const props = defineProps<propType>()

const { dt } = useDirectusTranslation()
</script>

<template>
  <div>
    <BlockBase class="signature-page:!bg-signature-black signature-page:block-light:!bg-signature-darkGray">
      <Container>
        <ol class="grid grid-cols-1 my-4rem gap-2rem md:grid-cols-2 lg:my-16rem">
          <template v-for="item, index in dt(props.data.translations)?.items" :key="index">
            <li>
              <div class="grid grid-cols-1 h-full gap-2rem border border-neutral-darkGray p-2rem sm:grid-cols-[min-content_1fr] signature-page:border-signature/14">
                <span class="text-3rem text-neutral-darkGray font-title -mt-.6rem signature-page:text-signature">{{ String(index + 1).padStart(3, '0') }}</span>
                <div>
                  <h2 class="text-2.2rem">
                    {{ item.title }}
                  </h2>
                  <p class="mt-1.2rem text-1.6rem">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </li>
          </template>
        </ol>
      </Container>
    </BlockBase>
  </div>
</template>

<style>

</style>
